
export const mapAgentAsSublabel = (agent:{idAgent: string}): JSX.Element => `Internal ID: ${agent.idAgent}`;
